import {
  FlatList,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import { categoriesList } from "../../../../components/DiscountsPerCategoryCard/categories";
import { FontAwesome } from "@expo/vector-icons";
import { Button, Modal, Portal } from "react-native-paper";
import CloseIcon from "../../../../../assets/images/utils/CloseIcon";
import { Filters } from "../../../../components/ExclusiveDiscounts";
import FilterRow from "./FilterRow";
type sortDiscountsType = "new" | "popular";
const CategoryFilters = ({
  filters,
  sort,
  setFilters,
  setSort,
}: {
  filters: Filters;
  sort: sortDiscountsType;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  setSort: React.Dispatch<React.SetStateAction<sortDiscountsType>>;
}) => {
  const categoriesNames = categoriesList.map((c) => c.category);
  const [filterModal, setFilterModal] = useState(false);
  const [sortModal, setSortModal] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState<Filters>(filters);
  const toggleFilterModal = () => setFilterModal(!filterModal);
  const toggleSortModal = () => setSortModal(!sortModal);
  const setSelectedFilter = (filter: keyof Filters, value: string) => {
    setSelectedFilters({ ...selectedFilters, [filter]: value });
  };
  useEffect(() => {
    setSelectedFilters(filters);
  }, [filters]);
  const handleApplyFilters = () => {
    setFilters(selectedFilters);
    setFilterModal(false);
  };
  const handleApplySort = (s: sortDiscountsType) => {
    setSort(s);
    setSortModal(false);
  };
  return (
    <View style={styles.root}>
      <TouchableOpacity style={styles.filterBtn} onPress={toggleFilterModal}>
        <Text style={styles.filterText}>Filtrar</Text>
        <FontAwesome name="chevron-down" size={10} color="#6D7F80" />
      </TouchableOpacity>
      <TouchableOpacity style={styles.filterBtn} onPress={toggleSortModal}>
        <Text style={styles.filterText}>Ordenar</Text>
        <FontAwesome name="chevron-down" size={10} color="#6D7F80" />
      </TouchableOpacity>
      <Portal>
        <Modal
          visible={filterModal}
          style={styles.modal}
          onDismiss={toggleFilterModal}
        >
          <View style={styles.modalContainer}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>Aplicar Filtros</Text>
              <TouchableOpacity
                onPress={toggleFilterModal}
                style={styles.closeIcon}
              >
                <CloseIcon />
              </TouchableOpacity>
            </View>
            <View style={styles.modalContent}>
              <FilterRow
                list={categoriesNames}
                selected={selectedFilters.category}
                title="Categoria"
                setFilter={(v) => setSelectedFilter("category", v)}
              />
              <FilterRow
                title="Região"
                list={["Todas", "Nacional", "Internacional"]}
                selected={selectedFilters.region}
                setFilter={(v) => setSelectedFilter("region", v)}
              />
              <FilterRow
                title="Tipo de desconto"
                list={["Todas", "Loja Online", "Loja Física"]}
                selected={selectedFilters.discountType}
                setFilter={(v) => setSelectedFilter("discountType", v)}
              />
              <Button
                mode="contained"
                style={styles.applyBtn}
                labelStyle={{ color: "#fff" }}
                onPress={handleApplyFilters}
              >
                Ver descontos
              </Button>
            </View>
          </View>
        </Modal>
        <Modal
          visible={sortModal}
          onDismiss={toggleSortModal}
          style={styles.modal}
        >
          <View style={styles.modalContainer}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>Ordenar</Text>
              <TouchableOpacity
                onPress={toggleSortModal}
                style={styles.closeIcon}
              >
                <CloseIcon />
              </TouchableOpacity>
            </View>
            <View style={styles.modalContent}>
              <Button
                mode="contained"
                style={[
                  styles.applyBtn,
                  sort !== "popular" && { backgroundColor: "#e1e8e8" },
                ]}
                labelStyle={{ color: sort !== "popular" ? "#8ea3a4" : "#fff" }}
                onPress={() => handleApplySort("popular")}
              >
                Mais populares
              </Button>
              <Button
                mode="contained"
                style={[
                  styles.applyBtn,
                  sort !== "new" && { backgroundColor: "#e1e8e8" },
                ]}
                labelStyle={{ color: sort !== "new" ? "#8ea3a4" : "#fff" }}
                onPress={() => handleApplySort("new")}
              >
                Mais novos
              </Button>
            </View>
          </View>
        </Modal>
      </Portal>
    </View>
  );
};

export default CategoryFilters;

const styles = StyleSheet.create({
  root: {
    marginHorizontal: "5%",
    marginBottom: 25,
    marginTop: 12,
    flexDirection: "row",
  },
  filterBtn: {
    paddingVertical: 7,
    paddingLeft: 10,
    paddingRight: 5,
    backgroundColor: "#e1e8e8",
    borderRadius: 9,
    marginRight: 10,
    flexDirection: "row",
    alignItems: "center",
  },
  filterText: {
    color: "#6D7F80",
    fontSize: 16,
    fontWeight: "600",
    marginRight: 5,
  },
  modalContainer: {
    width: "100%",
    backgroundColor: "#fff",
    borderTopRightRadius: 40,
    borderTopLeftRadius: 40,
    zIndex: 16,
  },
  modal: { justifyContent: "flex-end" },
  modalHeader: {
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 20,
    flexDirection: "row",
    marginBottom: 25,
  },
  modalTitle: {
    fontSize: 16,
    fontWeight: "700",
  },
  closeIcon: {
    position: "absolute",
    right: 25,
    top: 25,
  },
  modalContent: {
    marginVertical: 10,
    width: "90%",
    marginHorizontal: "5%",
  },
  applyBtn: { borderRadius: 25, marginTop: 12 },
});
